import React from 'react';
import styled from 'styled-components';
import { translate } from '../../../Services/translation';
import { btn } from '../../../styling/mixins/buttons';
import EditorString from '../../EditorString/EditorString';
import ResponsiveImage from '../../ResponsiveImage/ResponsiveImage';

const StyledBrandTab = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  .brand-image-wrapper {
    margin-bottom: 2.4rem;
  }
  picture {
    max-width: 100px;
    display: block;
  }
`;

const StyledBrandButton = styled.a`
  margin-top: 2.4rem;
  ${btn('primary', 'large')};
`;

const BrandTab = ({ brand }) => {
  return (
    <>
      {brand && (
        <StyledBrandTab>
          {brand.url ? (
            <a className="brand-image-wrapper" href={brand.url}>
              <ResponsiveImage {...brand.image} />
            </a>
          ) : (
            <ResponsiveImage {...brand.image} />
          )}
          {brand.text && <EditorString value={brand.text.value} />}
          <StyledBrandButton href={brand.url}>
            {translate('product-tabs.brand-link')}
          </StyledBrandButton>
        </StyledBrandTab>
      )}
    </>
  );
};

export default BrandTab;
